/* eslint-disable no-restricted-syntax */
import useOptimizelyFeature from './useOptimizelyFeature';
const allowedDomains = ['www.autotrader.com', 'www.kbb.com', 'www.fordblueadvantage.com', 'test.autotrader.com', 'preview.autotrader.com', 'staging.kbb.com', 'test.fordblueadvantage.com'];

/*
 * Returns either the Optimizely Web or Edge snippet to be used in the applications head tag
 * Usage:
 * const [optimizelySnippet] = useOptimizelySnippet({ canonical, query, page });
 *
 * <Head>
 *      {optimizelySnippet &&
 *          <script src={optimizelySnippet} />
 *      }
 * </Head>
 */
const useOptimizelySnippet = ({
  url = '',
  thirdPartyEnabled,
  pageName,
  query
}) => {
  const [isEnabled, variables] = useOptimizelyFeature('optimizely_snippet');
  const isSnippetEnabled = isEnabled && variables.pages && variables.pages[pageName];
  if (!thirdPartyEnabled || !isSnippetEnabled) {
    return [null];
  }
  let snippet = variables.snippet_url;
  if (snippet.startsWith('//')) {
    snippet = 'https:' + snippet;
  }
  const formattedUrl = new URL(snippet);

  // Only serve the snippet from allowed domains
  if (!allowedDomains.includes(formattedUrl.hostname)) {
    return [null];
  }
  if (variables.append_edge_params) {
    if (!url || !query || !pageName) {
      // eslint-disable-next-line no-console
      console.error('[Optimizely] - One or more of the required Optimizely Edge params are missing: `url`, `query`, `pageName`. Make sure these are present as function arguments.');
      return [null];
    }
    try {
      const parsedUrl = new URL(url);

      // Handle localhost case
      if (parsedUrl.hostname === 'localhost') {
        parsedUrl.hostname = 'www.autotrader.com';
        parsedUrl.host = 'www.autotrader.com';
        parsedUrl.port = '';
      }

      // Clear existing search params
      parsedUrl.search = '';

      // Add query params
      for (const [key, value] of Object.entries(query)) {
        if (value !== undefined && value !== null) {
          parsedUrl.searchParams.append(key, value);
        }
      }

      // Add page name param
      parsedUrl.searchParams.append('pg', pageName);

      // Append the encoded URL to the snippet
      snippet += encodeURIComponent(parsedUrl.toString());
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[Optimizely] - Error parsing URL:', error);
      return [null];
    }
  }
  return [snippet, variables.preload_snippet];
};
export default useOptimizelySnippet;